export default function packageViewReducer( state = {}, action )
{
    switch( action.type )
    {
        case 'DOC_FETCH_SUCCEEDED':
            return action.pkg;

        default:
            return state;
    }
};




// WEBPACK FOOTER //
// ./src/lib/reducers/doc-view.js